<div class="page-topbar">
  <img class="page-topbar-logo" src="assets/img/somfy.svg" alt="Somfy" />
</div>
